import * as t from 'io-ts';
import { createLocalStorageItem } from 'src/AppState/LocalStorageState/createLocalStorageItem';
import { LocalStorageItemState } from 'src/AppState/LocalStorageState/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const decodeIO = t.record(t.string, t.string);

const decode = buildValidator('localStorageChatDrafts.decodeIO', decodeIO, true);

export const localStorageChatDrafts = (
    withAutorun: boolean,
    key: string
): LocalStorageItemState<Record<string, string>> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: {},
    });
};
